jQuery(document).ready(function ($) {

  //ABRIR MENU MOBILE
  $('.abrir-menu-container, .menu-mobile .botao-fechar').click(function (e) {
    e.preventDefault();
    if (!$('.menu-mobile').hasClass('menu-site-aberto')) {
      abreMenu();
    } else {
      fechaMenu();
    }
  });
  $('.menu-overlay').click(function (e) {
    e.preventDefault();
    if (!$('.menu-overlay').hasClass('menu-overlay-aberto')) {
      abreMenu();
    } else {
      fechaMenu();
    }
  });

  function abreMenu() {
    $('.menu-mobile').addClass('menu-site-aberto');
    $('.menu-overlay').addClass('menu-overlay-aberto');
  }

  function fechaMenu() {
    $('.menu-mobile').removeClass('menu-site-aberto');
    $('.menu-overlay').removeClass('menu-overlay-aberto');
  }

  //BALAO DO WHATS
  $('a.whats').click(function (e) {
    closeWhatsBallon();
  });

  $('.whats-balao').hover(function (e) {
    closeWhatsBallon();
  });

  function closeWhatsBallon() {
    $('.whats-balao').remove();
  }

  setTimeout(function () {
    closeWhatsBallon();
  }, 10000);

  //GALERIA
  $('.galeria-page a, a.galeria-campo, a.fotos-capa').magnificPopup({
    type: 'image', gallery: {
      enabled: true, tPrev: 'Anterior', tNext: 'Próxima', tCounter: '%curr% de %total%'
    }
  });

  //CARROSSEIS
  $('.hero-carrosel').owlCarousel({
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 3000,
    dots: false,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: false,
    items: 1
  });

  $('.destaques-carrosel').owlCarousel({
    loop: false,
    margin: 30,
    autoplay: false,
    autoplayTimeout: 5000,
    dots: false,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: true,
    autoHeight: false,
    responsive: {
      0: {
        items: 1
      }, 600: {
        items: 2
      }, 1000: {
        items: 4
      }
    }
  });

  $('.valores-carrosel').owlCarousel({
    loop: false,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 9000,
    dots: false,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: true,
    autoHeight: false,
    responsive: {
      0: {
        items: 1
      }, 750: {
        items: 2
      }, 1000: {
        items: 3
      }
    }
  });

  $('.parceiros-carrosel').owlCarousel({
    loop: true,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 6000,
    dots: true,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: false,
    autoHeight: false,
    responsive: {
      0: {
        items: 2
      }, 600: {
        items: 3
      }, 1000: {
        items: 6
      }
    }
  });

  $('.noticias-carrosel').owlCarousel({
    loop: false,
    margin: 30,
    autoplay: false,
    autoplayTimeout: 6000,
    dots: false,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: true,
    responsive: {
      0: {
        items: 1
      }, 600: {
        items: 3
      }, 1000: {
        items: 4
      }
    }
  });

  $('.depoimentos-carrosel').owlCarousel({
    loop: true,
    margin: 30,
    autoplay: true,
    autoplayTimeout: 5000,
    dots: false,
    lazyLoad: true,
    navText: ["&#8592;", "&#8594;"],
    nav: true,
    autoHeight: false,
    responsive: {
      0: {
        items: 1
      }, 600: {
        items: 1
      }, 1000: {
        items: 2
      }
    }
  });

  //FIX HEADER
  window.onscroll = function () {
    fixHeader()
  };

  function fixHeader() {
    if (window.pageYOffset > 70) {
      $('#topo').addClass('scrooled');
    } else {
      $('#topo').removeClass('scrooled');
    }
  }

  $('a.sem-link').click(function (e) {
    e.preventDefault();
  });

  //LOGO QUEIROZ
  const logoSVG = `
    <span class="brand-logo-inline" role="img" aria-label="QUEIROZ">
      <svg id="Layer_1" width="300" height="49" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 293.83 48.33">
  <defs>
    <style>
      .cls-1 {
        fill: #004a25;
      }
    </style>
  </defs>
  <path class="cls-1" d="M24.71,37.24c-7.03,0-12.99-6.16-12.99-13.46s5.96-13.4,12.99-13.4,12.99,6.16,12.99,13.4c0,1.94-.4,3.75-1.14,5.43l-3.64-3.07-12.57.09,10.52,9.34c-1.81,1.07-3.95,1.67-6.16,1.67M49.5,23.78C49.5,10.85,38.18,0,24.71,0S0,10.85,0,23.78s11.32,23.84,24.71,23.84c5.43,0,10.45-1.74,14.6-4.69l4.01,3.5,13.05.1-11.1-9.7c2.68-3.75,4.22-8.31,4.22-13.06Z"/>
  <path class="cls-1" d="M257.15,47.28v-8.18l22.2-27.45h-21.45V2.27h35.85v8.55l-21.83,27.08h21.9v9.38h-36.68ZM230.37,37.75c3.4,0,6.24-1.2,8.51-3.6,2.28-2.4,3.41-5.53,3.41-9.38s-1.14-6.98-3.41-9.38c-2.28-2.4-5.11-3.6-8.51-3.6s-6.15,1.2-8.4,3.6c-2.25,2.4-3.38,5.53-3.38,9.38s1.13,6.98,3.38,9.38c2.25,2.4,5.05,3.6,8.4,3.6ZM230.37,48.33c-6.7,0-12.21-2.29-16.54-6.86-4.33-4.58-6.49-10.14-6.49-16.69s2.16-12.1,6.49-16.65c4.33-4.55,9.84-6.83,16.54-6.83s12.3,2.28,16.65,6.83c4.35,4.55,6.53,10.1,6.53,16.65s-2.18,12.11-6.53,16.69-9.9,6.86-16.65,6.86ZM191.22,17.42c0-1.9-.63-3.34-1.88-4.31-1.25-.98-2.9-1.46-4.95-1.46h-8.25v11.63h8.33c2,0,3.63-.51,4.88-1.54,1.25-1.03,1.88-2.46,1.88-4.31ZM165.26,2.27h19.88c5.1,0,9.26,1.43,12.49,4.28,3.23,2.85,4.84,6.48,4.84,10.88,0,3.05-.74,5.74-2.21,8.06-1.48,2.33-3.54,4.09-6.19,5.29v.83l10.13,14.93v.75h-12.38l-9.38-14.78h-6.3v14.78h-10.88V2.27ZM155.96,2.27v45.01h-10.88V2.27h10.88ZM134.29,20.2v8.55h-18.3v9.15h21.83v9.38h-32.7V2.27h32.7v9.38h-21.83v8.55h18.3ZM76.45,48.33c-6,0-10.83-1.94-14.48-5.81-3.65-3.88-5.48-8.76-5.48-14.66V2.27h10.88v25.58c0,2.95.78,5.34,2.33,7.16,1.55,1.83,3.8,2.74,6.75,2.74s5.26-.91,6.79-2.74c1.53-1.83,2.29-4.21,2.29-7.16V2.27h10.88v25.58c0,5.95-1.8,10.85-5.4,14.7-3.6,3.85-8.45,5.78-14.55,5.78Z"/>
</svg>
    </span>
  `;

  // 2) Onde procurar? Ajuste para o “miolo” do site
  const $scope = $('#pagina'); // refine se precisar
  console.log('escopos', $scope);

  // 3) Troca apenas em nós de texto (sem mexer em script/style/etc)
  const SKIP = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'CODE', 'PRE']);
  const EXCLUDE_SELECTOR = '.nao-trocar-logo';

  function replaceInTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !/queiroz/i.test(node.nodeValue)) {
          return NodeFilter.FILTER_REJECT;
        }
        const p = node.parentNode;

        if (!p || SKIP.has(p.nodeName)) return NodeFilter.FILTER_REJECT;

        // EXCLUSÃO POR CLASSE
        if (p.closest && p.closest(EXCLUDE_SELECTOR)) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((textNode) => {
      const parts = textNode.nodeValue.split(/QUEIROZ/i);
      if (parts.length <= 1) return;

      const frag = document.createDocumentFragment();
      parts.forEach((part, i) => {
        frag.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) {
          const tmp = document.createElement('span');
          tmp.innerHTML = logoSVG.trim();
          frag.appendChild(tmp.firstElementChild);
        }
      });

      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  $scope.each(function () {
    replaceInTextNodes(this);
  });


});